// extracted by mini-css-extract-plugin
module.exports = {"imageBg":"vision-module--imageBg--1crAp","opening":"vision-module--opening--229pe","vision":"vision-module--vision--3zzUk"};